interface AddOptions {
  url: string;
  name: string;
  descriptors?: FontFaceDescriptors;
}

class FontFaceLoaderClass {
  private queue: Map<string, FontFace> = new Map();

  async add(options: AddOptions): Promise<boolean> {
    const { name, url } = options;
    const font = new FontFace(name, `url(${url})`);

    if (name && url && !this.hasFont(name, font)) {
      return this.load(name, font);
    }

    return false;
  }

  private hasFont(name: string, font: FontFace): boolean {
    return (
      FontFaceLoaderClass.hasFontInDocument(font) ||
      this.hasFontInQueue(name) !== undefined
    );
  }

  private hasFontInQueue(name: string) {
    return this.queue.get(name);
  }

  private async load(name: string, font: FontFace): Promise<boolean> {
    this.queue.set(name, font);

    try {
      await font.load();
      const result = FontFaceLoaderClass.addFontToDocument(font);
      this.queue.delete(name);

      return result;
    } catch (e) {
      console.warn(e);
    }

    return false;
  }

  private static hasFontInDocument(font: FontFace): boolean {
    return FontFaceLoaderClass.hasDocument && document.fonts.has(font);
  }

  private static addFontToDocument(font: FontFace): boolean {
    if (FontFaceLoaderClass.hasDocument) {
      document.fonts.add(font);

      return true;
    }

    return false;
  }

  protected static get hasDocument(): boolean {
    return typeof document === "object" && document instanceof Document;
  }
}

const FontFaceLoader = new FontFaceLoaderClass();

export { FontFaceLoader };
